import React from 'react'
import { Link } from 'react-router-dom'
import { Clock, ArrowRight, Cpu } from 'lucide-react'
import Navigation from '../../components/common/Navigation'
import Footer from '../../components/common/Footer'
import { ARTICLES } from '../../features/tech-hub/techArticles'

const TechHubPage: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex flex-col">
    <Navigation />
    <main className="flex-1">
      <section className="mx-auto max-w-5xl px-4 py-10 sm:py-14">
        <div className="flex items-center gap-3">
          <span className="grid h-12 w-12 place-items-center rounded-2xl bg-blue-600 text-white"><Cpu size={26} /></span>
          <div>
            <p className="text-[11px] font-black uppercase tracking-widest text-blue-600">Vật Lí 365</p>
            <h1 className="text-2xl sm:text-3xl font-black text-slate-900">Công nghệ số dành cho giáo viên</h1>
          </div>
        </div>
        <p className="mt-3 max-w-2xl text-base sm:text-lg text-slate-600">
          Ứng dụng AI, STEM và công nghệ số vào dạy học — thiết thực, cập nhật, có tài liệu tải kèm.
        </p>

        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/cong-nghe-so/${a.slug}`}
              className="group flex flex-col rounded-3xl border border-slate-100 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md no-underline"
            >
              <div className="flex items-center gap-2 text-xs font-black uppercase tracking-wide text-blue-600">
                <span>{a.tag}</span>
                <span className="text-slate-300">·</span>
                <span className="inline-flex items-center gap-1 text-slate-400"><Clock size={12} /> {a.readMin}′</span>
              </div>
              <h2 className="mt-2 text-lg font-black leading-snug text-slate-900">{a.emoji} {a.title}</h2>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{a.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-black text-blue-600">
                Đọc bài <ArrowRight size={15} className="transition group-hover:translate-x-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </main>
    <Footer />
  </div>
)

export default TechHubPage
